import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { fetchData } from "src/services/dashboard.service";
import { addTag, deleteTag, fetchTagList, updateTag } from "src/services/tag.service";
import { getAuthToken } from "../config";

export const doFetchTagList = createAsyncThunk(
  "prediction/fetchPredictionList",
  async (payload: { search?: string; page: number; limit: number }) => {
    try {
      const response: any = await fetchTagList({
        search: payload.search,
        page: payload.page,
        limit: payload.limit,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch tag list";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doAddTag= createAsyncThunk(
  "tag/addTag",
  async (body: any, { getState, rejectWithValue }) => {
    const accessToken = getAuthToken();
    if (!accessToken) {
      throw new Error("Authentication token not found");
    }
    try {
      const response: any = await addTag(body);
      return response;
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Failed to add tag");
      return rejectWithValue(
        error.response?.data?.message || "Failed to add tag"
      );
    }
  }
);

export const doUpdateTag = createAsyncThunk(
  "tag/updateTag",
  async (
    { id, body }: { id: string; body: { title: string;} },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await updateTag(id, body);
      toast.success("Tag updated successfully!");
      return { id, data: response.data };
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Failed to update tag";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const doDelTag = createAsyncThunk(
  "tag/delTag",
  async (id: string) => {
    try {
      const response: any = await deleteTag(id);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete tag";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);